module.exports = __webpack_public_path__ + "static/img/baseindicaciones-contenido.008397b6.jpg";